// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-header-variants-header-variant-1-topLine-bgkau{height:28px}.components-header-variants-header-variant-1-header-bpkdw{margin-bottom:16px!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"topLine": "components-header-variants-header-variant-1-topLine-bgkau",
	"header": "components-header-variants-header-variant-1-header-bpkdw"
};
module.exports = ___CSS_LOADER_EXPORT___;
